// extracted by mini-css-extract-plugin
export var addToCartButton = "_q9-b";
export var arrowButtonContainer = "_q9-9";
export var arrowButtonIcon = "_q9-a";
export var carouselArrowButton = "_q9-6";
export var carouselElementContainer = "_q9-1";
export var left = "_q9-7";
export var productDisplayCarouselContainer = "_q9-0";
export var productTileContainer = "_q9-2";
export var productTileImage = "_q9-4";
export var productTileImageContainer = "_q9-3";
export var productTileTitle = "_q9-5";
export var right = "_q9-8";
export var sliderOverflow = "_q9-c";